import { render } from "./EventReviewView.vue?vue&type=template&id=503d4e81&scoped=true"
import script from "./EventReviewView.vue?vue&type=script&lang=js"
export * from "./EventReviewView.vue?vue&type=script&lang=js"

import "./EventReviewView.vue?vue&type=style&index=0&id=503d4e81&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503d4e81"]])

export default __exports__